import { forwardRef } from 'react';
import { Flex as RadixFlex } from '@radix-ui/themes';
import type { RadixComponentProps } from '@/types/radix-ui';

/**
 * Flex component - wrapper around Radix UI Flex
 * Provides all functionality of the original component while allowing
 * for centralized customization and future extensions.
 */
export type FlexProps = RadixComponentProps<typeof RadixFlex>;

const Flex = forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  return <RadixFlex ref={ref} {...props} />;
});

Flex.displayName = 'Flex';

export { Flex };
